module.exports = "<app-activities *ngFor=\"let involvement of itemsFormArray.controls; let i=index\" [index]=\"i\" [involvement]=\"involvement\"\n  (removed)=\"itemsFormArray.removeAt($event)\">\n</app-activities>\n<button type=\"button\" class=\"btn btn-outline-involvement btn-sm float-right\" (click)=\"addItem()\">I have more involvements</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/involvements/involvements.component.html
// module id = ./src/app/main/content/involvements/involvements.component.html
// module chunks = main